"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const api_external_contract_js_1 = require("@tableau/api-external-contract-js");
const api_internal_contract_js_1 = require("@tableau/api-internal-contract-js");
const api_shared_js_1 = require("@tableau/api-shared-js");
const DashboardLayoutChangedEvent_1 = require("../Events/DashboardLayoutChangedEvent");
const WorkbookFormattingChangedEvent_1 = require("../Events/WorkbookFormattingChangedEvent");
const ServiceRegistryUtil_1 = require("../Services/ServiceRegistryUtil");
const DashboardObject_1 = require("./DashboardObject");
const Sheet_1 = require("./Sheet");
const Worksheet_1 = require("./Worksheet");
class Dashboard extends Sheet_1.Sheet {
    constructor(_dashboardImpl) {
        super(_dashboardImpl);
        this._dashboardImpl = _dashboardImpl;
        _dashboardImpl.initializeWithPublicInterfaces();
        this.initializeEvents().forEach((e) => this.addNewEventType(e));
    }
    get worksheets() {
        return this._dashboardImpl.worksheetsImpl.map((worksheetImpl) => {
            return new Worksheet_1.Worksheet(worksheetImpl);
        });
    }
    get objects() {
        return this._dashboardImpl.objects.map((dashboardObjectImpl) => {
            return new DashboardObject_1.DashboardObject(dashboardObjectImpl);
        });
    }
    get activeDashboardObjectId() {
        return this._dashboardImpl.activeDashboardObjectId;
    }
    get activeDashboardName() {
        return this._dashboardImpl.activeDashboardName;
    }
    setZoneVisibilityAsync(zoneVisibilityMap) {
        return this._dashboardImpl.setDashboardObjectVisibilityAsync(zoneVisibilityMap);
    }
    setDashboardObjectVisibilityAsync(dashboardObjectVisibilityMap) {
        return this._dashboardImpl.setDashboardObjectVisibilityAsync(dashboardObjectVisibilityMap);
    }
    getDashboardObjectById(dashboardObjectId) {
        const zone = this._dashboardImpl.getDashboardObjectById(dashboardObjectId);
        return zone && new DashboardObject_1.DashboardObject(zone);
    }
    initializeEvents() {
        const results = new Array();
        // Initializing events and registering notification service
        let notificationService;
        try {
            notificationService = api_shared_js_1.ApiServiceRegistry.get(ServiceRegistryUtil_1.ExtensionsRegistryId).getService("notification-service" /* Notification */);
        }
        catch (e) {
            // If we don't have this service registered, just return (allows unit testing without NotificationService mock)
            return results;
        }
        const dashboardLayoutChangedEvent = new api_shared_js_1.SingleEventManagerImpl(api_external_contract_js_1.TableauEventType.DashboardLayoutChanged);
        notificationService.registerHandler(api_internal_contract_js_1.NotificationId.DashboardLayoutChanged, () => true, (event) => {
            const dashboardObjectChanges = this._dashboardImpl.updateZones(event.zones, event.activeZoneId, event.activeDashboardName);
            dashboardLayoutChangedEvent.triggerEvent(() => new DashboardLayoutChangedEvent_1.DashboardLayoutChangedEvent(dashboardObjectChanges));
        });
        results.push(dashboardLayoutChangedEvent);
        const workbookFormattingChangedEvent = new api_shared_js_1.SingleEventManagerImpl(api_external_contract_js_1.TableauEventType.WorkbookFormattingChanged);
        notificationService.registerHandler(api_internal_contract_js_1.NotificationId.WorkbookFormattingChanged, () => true, (eventFormatting) => {
            workbookFormattingChangedEvent.triggerEvent(() => new WorkbookFormattingChangedEvent_1.WorkbookFormattingChangedEvent(eventFormatting));
        });
        results.push(workbookFormattingChangedEvent);
        return results;
    }
    moveAndResizeDashboardObjectsAsync(dashboardObjectPositionAndSizeUpdateArray) {
        return this._dashboardImpl.moveAndResizeDashboardObjectsAsync(dashboardObjectPositionAndSizeUpdateArray);
    }
    replayAnimationAsync(replaySpeed) {
        return this._dashboardImpl.replayAnimationAsync(replaySpeed);
    }
    getFiltersAsync() {
        return this._dashboardImpl.getFiltersAsync();
    }
    applyFilterAsync(fieldName, values, updateType, options) {
        return this._dashboardImpl.applyFilterAsync(fieldName, values, updateType, options);
    }
}
exports.Dashboard = Dashboard;
//# sourceMappingURL=Dashboard.js.map